import { render, staticRenderFns } from "./ImportOnderdeelKoppeling.vue?vue&type=template&id=08f2c618"
import script from "./ImportOnderdeelKoppeling.vue?vue&type=script&lang=js"
export * from "./ImportOnderdeelKoppeling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports